import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';
import lottie from 'lottie-web';

function init() {
  if (!$('[data-au-forms')) return;

  addEventListeners();
}

/**
 *
 * Function to show or hide forms with segmented controls inside Tools / Forms module
 */
function addEventListeners() {
  $$('[data-au-forms] [data-au-segmented-control]').forEach((el) => {
    el.addEventListener('click', formSelection);
  });

  $$('[data-au-forms] [data-au-form-block-text] a').forEach((el) => {
    el.addEventListener('click', formsDatalayerFormsTextLinks);
  });

  if ($('[data-au-forms-lottie]')) formsLottieAnimation();
}

function formSelection(e) {
  const trigger = e.currentTarget;
  const triggerId = trigger.dataset.auSegmentedControl;
  const target = $(`[data-au-form-block="${triggerId}"]`);
  let controlsTitle;

  if (trigger.closest('[data-au-forms-segmented-controls]').querySelector('[data-au-forms-segmented-controls-title]')) {
    controlsTitle = removeAccentMarkAndUppercase(
      trigger.closest('[data-au-forms-segmented-controls]').querySelector('[data-au-forms-segmented-controls-title]')
        .innerText,
    );
  } else {
    controlsTitle = '';
  }

  const targetTitle = removeAccentMarkAndUppercase(
    trigger.querySelector('[data-au-segmented-control-title]').innerText,
  );
  const item_id = `${controlsTitle}_${targetTitle}`;

  e.currentTarget
    .closest('[data-au-tab-content]')
    .querySelectorAll('[data-au-form-block]')
    .forEach((formBlock) => {
      formBlock.classList.add('au-hide');
      formBlock.classList.remove('au-active');
    });

  target.classList.add('au-active');
  target.classList.remove('au-hide');

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickCard',
    item_id,
  });
}

function formsDatalayerFormsTextLinks(e) {
  let titleText = e.currentTarget.closest('[data-au-form-block-text]').querySelector('[data-au-form-title]').innerText,
    clickText = e.currentTarget.querySelector(':not([data-au-icon])').innerText;
  const content_type = e.currentTarget.hasAttribute('download') ? 'clickDescarga' : 'clickEnlace';

  titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;
  clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

  const item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);

  window.dataLayer.push({
    event: 'navigation',
    content_type,
    item_id,
  });
}

function formsLottieAnimation() {
  const lottieContainer = $('[data-au-forms-lottie]');
  const lottiePath = $('[data-au-forms-lottie]').dataset.auFormsLottie;

  lottie.loadAnimation({
    container: lottieContainer,
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: lottiePath,
  });
}

export default { init };
